@if (isRenderFilters) {
    <div class="ng-filters">
        <app-smart-filters place="desktop-sidebar" displayMode="button"/>
        <div class="ng-filters-divider"></div>

        <app-tours-sort/>

        @if (filterPrices) {
            <div class="ng-filters-divider"></div>
            <app-price-filter [filterPrices]="filterPrices"
                              (filterChanged)="onAdditionalFilterChanged()"/>
        }

        @if (isTagsLoading || tags?.length) {
            <div class="ng-filters-divider"></div>
            @if (isTagsLoading) {
                <div class="tags-filter-skeleton">
                    <div class="tags-filter-skeleton__title"></div>
                    <div class="tags-filter-skeleton__list">
                        <div class="tags-filter-skeleton__pill"></div>
                        <div class="tags-filter-skeleton__pill"></div>
                        <div class="tags-filter-skeleton__pill tags-filter-skeleton__pill_wide"></div>
                        <div class="tags-filter-skeleton__pill"></div>
                        <div class="tags-filter-skeleton__pill tags-filter-skeleton__pill_wide"></div>
                        <div class="tags-filter-skeleton__pill"></div>
                        <div class="tags-filter-skeleton__pill tags-filter-skeleton__pill_short"></div>
                    </div>
                </div>
            } @else {
                <app-tags-filter [tags]="tags"
                                 (filterChanged)="onAdditionalFilterChanged()"/>
            }
        }

        <div class="ng-recommendation-filter">
            <app-filter [isOpen]="true"
                        [filter]="onlyRecommendedHotels"
                        [onlySmartFilter]="onlySmartFilter"
                        (changeSelectedCount)="changeSelectedCount($event)"></app-filter>
        </div>

        <div class="ng-filters-container">
            @for (filter of filters; track filter.filterKey) {
                <app-filter [isOpen]="true"
                            [filter]="filter"
                            [onlySmartFilter]="onlySmartFilter"
                            (changeSelectedCount)="changeSelectedCount($event)"></app-filter>
            }
        </div>

        <div class="ng-filters-footer" *ngIf="hasFooterActions()">
            <div class="ng-filters-footer__actions">
                <button *ngIf="hasSelectedFilters()"
                        type="button"
                        class="ng-reset-filter"
                        (click)="onResetFilters()">
                    <span class="ng-reset-title">{{ messages.resetFilters }}</span>
                </button>
                <button *ngIf="isShowApplyButton"
                        type="button"
                        class="ng-apply-filters"
                        (click)="applyFilters()">
                    {{ messages.applyFilters }}
                </button>
            </div>
        </div>
    </div>
}
